export const LANG_CODE = {
    "ZH":'zh',
    "EN":'en',
    "JP":"jp"
}

export const LANG_TEXT = {
    [LANG_CODE["ZH"]]:'中',
    [LANG_CODE["EN"]]:'ENG',
    [LANG_CODE["JP"]]:"日"
}

export const isSupportedLanguage = (checkCode) =>{
    for (let key in LANG_CODE) {
        if(checkCode===LANG_CODE[key]) return true;
    }
    return false
}


// WEBPACK FOOTER //
// ./src/constants/language-code.js